import React from "react";
import { isCardExpired } from "../../utils/common-utils";

const CardStatusTag = ({ bankTitle, expMonth, expYear }) => {
  const expire = isCardExpired(expMonth, expYear);

  return (
    <div>
      {bankTitle.toLowerCase()}{" "}
      {expire && <span className="expired-card">Expired</span>}
    </div>
  );
};

export default CardStatusTag;
